import howlingCover from '../assets/TH.jpg';
import musicHellCover from '../assets/MH.jpg';
import lobbyCover from '../assets/lobby.jpg';
import { projectMedia } from './sharedMedia';

/** Gallery image filenames under the shared luca-miro projects folder */
const GALLERY_FILES = {
  'curse-of-the-nile': [
    'WhatsApp Image 2025-11-30 adt 9.10.25 PM.jpeg',
    'WhatsApp Image 2025-11-30 ast 9.10.26 PM.jpeg',
    'WhatsApp Image 2025-11-30 at 9.10.24 PM.jpeg',
    'WhatsApp Image 2025-11-30 at 9.10.24s PM.jpeg',
    'WhatsApp Image 2025-11-30 at 9.10.25 PsM.jpeg',
    'WhatsApp Image 2025-11-30 at 9.10.2s6 PM.jpeg',
    'WhatsApp Image 2025-11-30 at 9.10s.24 PM.jpeg',
    'WhatsApp Image 2025-11-30 at 9.10s.26 PM.jpeg',
    'WhatsApp Image 2025-11-30 at 9.1s0.26 PM.jpeg',
    'WhatsApp Image 2025-11-30 at 9s.10.06 PM.jpeg',
    'WhatsApp Image 2025-11-30 at s9.10.08 PM.jpeg',
    'WhatsApp Image 2025-11-30 ats 9.10.22 PM.jpeg',
    'WhatsApp Image 2025-11-30 ats 9.10.25 PM.jpeg',
    'WhatsApp Image 2025-11-30 ats9.10.21 PM.jpeg',
    'WhatsApp Image 2025-11-30 sat 9.10.23 PM.jpeg',
    'WhatsApp Image 2025-11-30s at 9.10.21 PM.jpeg',
    'WhatsApp Image 2025-11-30s at 9.10.22 PM.jpeg',
    'WhatsApp Image 2025-11-3d0 ats 9.10.25 PM.jpeg',
    'WhatsApp Image 2025-11-3s0 at 9.10.23 PM.jpeg',
    'WhatsApp Image 2025-11-s30 at 9.10.22 PM.jpeg',
  ],
  deadzone: [
    'WhatsApp Image 2025-11-30 ast 9.07.09 PM.jpeg',
    'WhatsApp Image 2025-11-30 at 9.07.07 PM.jpeg',
    'WhatsApp Image 2025-11-30 at 9.07.08 PM.jpeg',
    'WhatsApp Image 2025-11-30 at 9.07.0s8 PM.jpeg',
    'WhatsApp Image 2025-11-30 at 9.0s7.08 PM.jpeg',
    'WhatsApp Image 2025-11-30s at 9.07.34 PM.jpeg',
  ],
  skywar: [
    'WhatsApp Image 2025-11-30 ast 9.08.17 PM.jpeg',
    'WhatsApp Image 2025-11-30 ast 9.12.57 PM.jpeg',
    'WhatsApp Image 2025-11-30 ast 9.12.58 PM.jpeg',
    'WhatsApp Image 2025-11-30 at 9.08.03 PM.jpeg',
    'WhatsApp Image 2025-11-30 at 9.08.15s PM.jpeg',
    'WhatsApp Image 2025-11-30 at 9.08.16 PM.jpeg',
    'WhatsApp Image 2025-11-30 at 9.08.17 PM.jpeg',
    'WhatsApp Image 2025-11-30 at 9.08.1s7 PM.jpeg',
    'WhatsApp Image 2025-11-30 at 9.12.56 PM.jpeg',
    'WhatsApp Image 2025-11-30 at 9.12.5s8 PM.jpeg',
    'WhatsApp Image 2025-11-30 at 9.12.s57 PM.jpeg',
    'WhatsApp Image 2025-11-30 at 9.12s.58 PM.jpeg',
    'WhatsApp Image 2025-11-30 at 9.13.00 PM.jpeg',
    'WhatsApp Image 2025-11-30 at 9.13.d0 PM.jpeg',
    'WhatsApp Image 2025-11-30 at 9.1s2.59 PM.jpeg',
    'WhatsApp Image 2025-11-30 at 9s.08.17 PM.jpeg',
    'WhatsApp Image 2025-11-30 at d9.13.00 PM.jpeg',
    'WhatsApp Image 2025-11-30 ats 9.08.18 PM.jpeg',
    'WhatsApp Image 2025-11-30s at 9.12.56 PM.jpeg',
    'WhatsApp Image 2025-11-30s at 9.12.57 PM.jpeg',
    'WhatsApp Image 2025-11-3d0 at 9.12.59 PM.jpeg',
    'WhatsApp Image 2025-s11-30 at 9.08.18 PM.jpeg',
    'WhatsApp Image 2025-s11-30 at 9.12.58 PM.jpeg',
    'WhatsApp Image 2025d-11-30 at 9.13.00 PM.jpeg',
    'WhatsApp Image 2025s-11-30 at 9.12.59 PM.jpeg',
    'WhatsApp Image 202d5-11-30 at 9.12.59 PM.jpeg',
  ],
  'italian-hotel': [
    'WhatsApp Image 2025-11-30 aat 9.11.33 PM.jpeg',
    'WhatsApp Image 2025-11-30 aat 9.11.34 PM.jpeg',
    'WhatsApp Image 2025-11-30 at 9.11.20 PM.jpeg',
    'WhatsApp Image 2025-11-30 at 9.11.29 PM.jpeg',
    'WhatsApp Image 2025-11-30 at 9.11.3s5 PM.jpeg',
    'WhatsApp Image 2025-11-30 at 9.11.s35 PM.jpeg',
    'WhatsApp Image 2025-11-30 at 9.1d1.33 PM.jpeg',
    'WhatsApp Image 2025-11-30 at 9.s11.29 PM.jpeg',
    'WhatsApp Image 2025-11-30 at 9s.11.35 PM.jpeg',
    'WhatsApp Image 2025-11-30 at s9.11.34 PM.jpeg',
    'WhatsApp Image 2025-11-30 ats 9.11.33 PM.jpeg',
    'WhatsApp Image 2025-11-30s at 9.11.31 PM.jpeg',
    'WhatsApp Image 2025-11-3d0 at 9.11.34 PM.jpeg',
    'WhatsApp Image 2025-11s-30 at 9.11.30 PM.jpeg',
    'WhatsApp Image 2025-1s1-30 at 9.11.30 PM.jpeg',
  ],
  fnaf: [
    'WhatsApp Image 2025-11-30 at 8.59.41 PM.jpeg',
    'WhatsApp Image 2025-11-30 at 8.59.42 PM.jpeg',
    'WhatsApp Image 2025-11-30 at 8.59.424 PM.jpeg',
    'WhatsApp Image 2025-11-30 at 8.59.43 PM.jpeg',
    'WhatsApp Image 2025-11-30 at 8.59.43 PM1.jpeg',
    'WhatsApp Image 2025-11-30 at 8.59.43 PM12.jpeg',
    'WhatsApp Image 2025-11-30 at 8.59.434 PM.jpeg',
    'WhatsApp Image 2025-11-30 at 8.59.44 PM.jpeg',
    'WhatsApp Image 2025-11-30 at 8.59.444 PM.jpeg',
  ],
  'midnight-manor': [
    'WhatsApp Image 2025-11-30 at 9.03.58 PM.jpeg',
    'WhatsApp Image 2025-11-30 at 9.03.59 PM.jpeg',
    'WhatsApp Image 2025-11-30 at 9.03.59d PM.jpeg',
    'WhatsApp Image 2025-11-30 at 9.04.0s0 PM.jpeg',
    'WhatsApp Image 2025-11-30 at 9.04s.00 PM.jpeg',
    'WhatsApp Image 2025-11-30 at 9.0s3.59d PM.jpeg',
    'WhatsApp Image 2025-11-30 at 9.0s4.02 PM.jpeg',
    'WhatsApp Image 2025-11-30 at 9.s04.00 PM.jpeg',
    'WhatsApp Image 2025-11-30 at 9d.03.59 PM.jpeg',
    'WhatsApp Image 2025-11-30 at s9.04.01 PM.jpeg',
    'WhatsApp Image 2025-11-30s at 9.04.01 PM.jpeg',
    'WhatsApp Image 2025-11s-30 at 9.04.02 PM.jpeg',
    'WhatsApp Image 2025-s11-30 at 9.04.01 PM.jpeg',
    'WhatsApp Image 202s5-11-30 at 9.04.01 PM.jpeg',
  ],
  locanda: [
    'WhatsApp Image 2025-11-30 ast 9.07.40 PM.jpeg',
    'WhatsApp Image 2025-11-30 at 9.07.34 PM.jpeg',
    'WhatsApp Image 2025-11-30 at 9.07.36 PM.jpeg',
    'WhatsApp Image 2025-11-30 at 9.07.38 PM.jpeg',
    'WhatsApp Image 2025-11-30 at 9.07.39 PM.jpeg',
    'WhatsApp Image 2025-11-30 at 9.07.40 PM.jpeg',
    'WhatsApp Image 2025-11-30 at 9.07.41 PM.jpeg',
    'WhatsApp Image 2025-11-30 at 9.0s7.41 PM.jpeg',
    'WhatsApp Image 2025-11-30 at 9d.07.41 PM.jpeg',
    'WhatsApp Image 2025-11-30 at s9.07.41 PM.jpeg',
  ],
  'selfie-studio': ['WhatsApp Image 2026-07-22 at 5.19.19 PM.jpeg'],
  horrorcon: ['WhatsApp Image 2026-07-29 at 6.52.34 PM.jpeg'],
  lucastar: [
    '1.jpeg',
    '10.jpeg',
    '11.jpeg',
    '12.jpeg',
    '13.jpeg',
    '14.jpeg',
    '15.jpeg',
    '16.jpeg',
    '17.jpeg',
    '19.jpeg',
    '20.jpeg',
    '21.jpeg',
    '22.jpeg',
    '23.jpeg',
  ],
  karting: ['1.jpg', '2.jpg', '3.jpg', '4.jpg', '5.jpg'],
  'a-lot-like-life': [
    '1.jpg',
    '2.jpg',
    '3.jpg',
    '4.jpg',
    '5.jpg',
    '6.jpg',
    '7.jpg',
    '8.jpg',
    '9.jpg',
    '10.jpg',
    '11.jpg',
    '12.jpg',
  ],
};

const FOLDER_BY_SLUG = {
  'curse-of-the-nile': 'Curse of the Nile',
  deadzone: 'Deadzone',
  skywar: 'Skywar',
  'italian-hotel': 'Italian Hotel',
  fnaf: 'FNAF',
  'midnight-manor': 'Midnight Manor',
  locanda: 'Locanda',
  'selfie-studio': 'Selfie Studio',
  horrorcon: 'Horrorcon',
  lucastar: 'Lucastar',
  karting: 'Karting',
  'a-lot-like-life': 'Alotlikelife',
};

function galleryUrls(slug) {
  const folder = FOLDER_BY_SLUG[slug];
  const files = GALLERY_FILES[slug] || [];
  if (!folder) return [];
  return files.map((file) => projectMedia(folder, file));
}

const projectImages = {
  'curse-of-the-nile': galleryUrls('curse-of-the-nile'),
  deadzone: galleryUrls('deadzone'),
  skywar: galleryUrls('skywar'),
  'italian-hotel': galleryUrls('italian-hotel'),
  fnaf: galleryUrls('fnaf'),
  'midnight-manor': galleryUrls('midnight-manor'),
  locanda: galleryUrls('locanda'),
  'a-lot-like-life': galleryUrls('a-lot-like-life'),
  howling: [howlingCover],
  'music-hell': [musicHellCover],
  'pubg-mobile': [lobbyCover],
  'pubg-saf': [projectMedia('SAF Pubg.png')],
  'aliens-vs-monsters': [projectMedia('SAF Aliens vs Monsters.png')],
  toots: [projectMedia('SAF Toots.png')],
  'selfie-studio': galleryUrls('selfie-studio'),
  horrorcon: galleryUrls('horrorcon'),
  lucastar: galleryUrls('lucastar'),
  karting: galleryUrls('karting'),
};

export const projectCovers = {
  'curse-of-the-nile': projectMedia(
    'Curse of the Nile',
    'WhatsApp Image 2025-11-30 at 9.10.24 PM.jpeg'
  ),
  deadzone: projectMedia('Deadzone', 'WhatsApp Image 2025-11-30 at 9.07.07 PM.jpeg'),
  skywar: projectMedia('Skywar', 'WhatsApp Image 2025-11-30 at 9.08.03 PM.jpeg'),
  'italian-hotel': projectMedia(
    'Italian Hotel',
    'WhatsApp Image 2025-11-30 at 9.11.20 PM.jpeg'
  ),
  fnaf: projectMedia('FNAF', 'WhatsApp Image 2025-11-30 at 8.59.41 PM.jpeg'),
  'midnight-manor': projectMedia(
    'Midnight Manor',
    'WhatsApp Image 2025-11-30 at 9.03.58 PM.jpeg'
  ),
  'a-lot-like-life': projectMedia('Alotlikelife', '1.jpg'),
  // Distinct from featured-card cover (1.jpg) for Award Winning Attractions
  'a-lot-like-life-award': projectMedia('Alotlikelife', '8.jpg'),
  lucastar: projectMedia('Lucastar', '1.jpeg'),
  horrorcon: projectMedia(
    'Horrorcon',
    'WhatsApp Image 2026-07-29 at 6.52.34 PM.jpeg'
  ),
  karting: projectMedia('Karting', '1.jpg'),
};

export default projectImages;
